import React from 'react';
import { Pricing } from '../components/Pricing';
import { motion } from 'framer-motion';
export function PricingPage() {
  return <div className="bg-sovereign-navy min-h-screen pt-20" data-id="element-280">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} className="text-center pt-12 pb-0" data-id="element-281">
        <span className="text-sovereign-gold uppercase tracking-widest text-sm" data-id="element-282">
          Membership
        </span>
      </motion.div>
      <Pricing data-id="element-283" />
    </div>;
}